import { TokenBalance } from 'types/token';

export const formatTokenBalance = (token: TokenBalance): string => {
  const displayDecimals = Math.min(token.decimals, 2);

  if (token.decimals === 0) {
    return token.balance.toString();
  }

  // Use BigInt string manipulation to avoid floating-point precision issues
  const balanceStr = BigInt(token.balance).toString();
  const decimals = token.decimals;

  if (balanceStr.length <= decimals) {
    const padded = balanceStr.padStart(decimals + 1, '0');
    const intPart = padded.slice(0, padded.length - decimals);
    const decPart = padded.slice(padded.length - decimals, padded.length - decimals + displayDecimals);
    return `${intPart}.${decPart}`;
  }

  const intPart = balanceStr.slice(0, balanceStr.length - decimals);
  const decPart = balanceStr.slice(balanceStr.length - decimals, balanceStr.length - decimals + displayDecimals);
  return `${intPart}.${decPart}`;
};
